module.exports = require('./helpers/bundle-url').getBundleURL('9kXrN') + "Roboto-msdf.6486be8c.png";